export const reloadOnBreakpoint = () => {
  const breakpoint = window.matchMedia("(max-width:768px)");

  breakpoint.addEventListener("change", () => {
    window.location.reload();
  });
};
